/**
 * Country Option structure for dropdown selection.
 */
export interface CountryOption {
  value: string;
  label: string;
  name: string;
}

/**
 * List of ISO 3166-1 alpha-2 country codes and country names.
 */
export const ISO_COUNTRY_CODES: CountryOption[] = [
  { value: 'AD', label: 'AD - Andorra', name: 'Andorra' },
  { value: 'AE', label: 'AE - United Arab Emirates', name: 'United Arab Emirates' },
  { value: 'AF', label: 'AF - Afghanistan', name: 'Afghanistan' },
  { value: 'AG', label: 'AG - Antigua and Barbuda', name: 'Antigua and Barbuda' },
  { value: 'AI', label: 'AI - Anguilla', name: 'Anguilla' },
  { value: 'AL', label: 'AL - Albania', name: 'Albania' },
  { value: 'AM', label: 'AM - Armenia', name: 'Armenia' },
  { value: 'AO', label: 'AO - Angola', name: 'Angola' },
  { value: 'AQ', label: 'AQ - Antarctica', name: 'Antarctica' },
  { value: 'AR', label: 'AR - Argentina', name: 'Argentina' },
  { value: 'AS', label: 'AS - American Samoa', name: 'American Samoa' },
  { value: 'AT', label: 'AT - Austria', name: 'Austria' },
  { value: 'AU', label: 'AU - Australia', name: 'Australia' },
  { value: 'AW', label: 'AW - Aruba', name: 'Aruba' },
  { value: 'AX', label: 'AX - Åland Islands', name: 'Åland Islands' },
  { value: 'AZ', label: 'AZ - Azerbaijan', name: 'Azerbaijan' },
  { value: 'BA', label: 'BA - Bosnia and Herzegovina', name: 'Bosnia and Herzegovina' },
  { value: 'BB', label: 'BB - Barbados', name: 'Barbados' },
  { value: 'BD', label: 'BD - Bangladesh', name: 'Bangladesh' },
  { value: 'BE', label: 'BE - Belgium', name: 'Belgium' },
  { value: 'BF', label: 'BF - Burkina Faso', name: 'Burkina Faso' },
  { value: 'BG', label: 'BG - Bulgaria', name: 'Bulgaria' },
  { value: 'BH', label: 'BH - Bahrain', name: 'Bahrain' },
  { value: 'BI', label: 'BI - Burundi', name: 'Burundi' },
  { value: 'BJ', label: 'BJ - Benin', name: 'Benin' },
  { value: 'BL', label: 'BL - Saint Barthélemy', name: 'Saint Barthélemy' },
  { value: 'BM', label: 'BM - Bermuda', name: 'Bermuda' },
  { value: 'BN', label: 'BN - Brunei', name: 'Brunei' },
  { value: 'BO', label: 'BO - Bolivia', name: 'Bolivia' },
  {
    value: 'BQ',
    label: 'BQ - Bonaire, Sint Eustatius and Saba',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  { value: 'BR', label: 'BR - Brazil', name: 'Brazil' },
  { value: 'BS', label: 'BS - Bahamas', name: 'Bahamas' },
  { value: 'BT', label: 'BT - Bhutan', name: 'Bhutan' },
  { value: 'BV', label: 'BV - Bouvet Island', name: 'Bouvet Island' },
  { value: 'BW', label: 'BW - Botswana', name: 'Botswana' },
  { value: 'BY', label: 'BY - Belarus', name: 'Belarus' },
  { value: 'BZ', label: 'BZ - Belize', name: 'Belize' },
  { value: 'CA', label: 'CA - Canada', name: 'Canada' },
  { value: 'CC', label: 'CC - Cocos (Keeling) Islands', name: 'Cocos (Keeling) Islands' },
  { value: 'CD', label: 'CD - Congo (DRC)', name: 'Congo (DRC)' },
  { value: 'CF', label: 'CF - Central African Republic', name: 'Central African Republic' },
  { value: 'CG', label: 'CG - Congo', name: 'Congo' },
  { value: 'CH', label: 'CH - Switzerland', name: 'Switzerland' },
  { value: 'CI', label: "CI - Côte d'Ivoire", name: "Côte d'Ivoire" },
  { value: 'CK', label: 'CK - Cook Islands', name: 'Cook Islands' },
  { value: 'CL', label: 'CL - Chile', name: 'Chile' },
  { value: 'CM', label: 'CM - Cameroon', name: 'Cameroon' },
  { value: 'CN', label: 'CN - China', name: 'China' },
  { value: 'CO', label: 'CO - Colombia', name: 'Colombia' },
  { value: 'CR', label: 'CR - Costa Rica', name: 'Costa Rica' },
  { value: 'CU', label: 'CU - Cuba', name: 'Cuba' },
  { value: 'CV', label: 'CV - Cape Verde', name: 'Cape Verde' },
  { value: 'CW', label: 'CW - Curaçao', name: 'Curaçao' },
  { value: 'CX', label: 'CX - Christmas Island', name: 'Christmas Island' },
  { value: 'CY', label: 'CY - Cyprus', name: 'Cyprus' },
  { value: 'CZ', label: 'CZ - Czechia', name: 'Czechia' },
  { value: 'DE', label: 'DE - Germany', name: 'Germany' },
  { value: 'DJ', label: 'DJ - Djibouti', name: 'Djibouti' },
  { value: 'DK', label: 'DK - Denmark', name: 'Denmark' },
  { value: 'DM', label: 'DM - Dominica', name: 'Dominica' },
  { value: 'DO', label: 'DO - Dominican Republic', name: 'Dominican Republic' },
  { value: 'DZ', label: 'DZ - Algeria', name: 'Algeria' },
  { value: 'EC', label: 'EC - Ecuador', name: 'Ecuador' },
  { value: 'EE', label: 'EE - Estonia', name: 'Estonia' },
  { value: 'EG', label: 'EG - Egypt', name: 'Egypt' },
  { value: 'EH', label: 'EH - Western Sahara', name: 'Western Sahara' },
  { value: 'ER', label: 'ER - Eritrea', name: 'Eritrea' },
  { value: 'ES', label: 'ES - Spain', name: 'Spain' },
  { value: 'ET', label: 'ET - Ethiopia', name: 'Ethiopia' },
  { value: 'FI', label: 'FI - Finland', name: 'Finland' },
  { value: 'FJ', label: 'FJ - Fiji', name: 'Fiji' },
  { value: 'FK', label: 'FK - Falkland Islands', name: 'Falkland Islands' },
  { value: 'FM', label: 'FM - Micronesia', name: 'Micronesia' },
  { value: 'FO', label: 'FO - Faroe Islands', name: 'Faroe Islands' },
  { value: 'FR', label: 'FR - France', name: 'France' },
  { value: 'GA', label: 'GA - Gabon', name: 'Gabon' },
  { value: 'GB', label: 'GB - United Kingdom', name: 'United Kingdom' },
  { value: 'GD', label: 'GD - Grenada', name: 'Grenada' },
  { value: 'GE', label: 'GE - Georgia', name: 'Georgia' },
  { value: 'GF', label: 'GF - French Guiana', name: 'French Guiana' },
  { value: 'GG', label: 'GG - Guernsey', name: 'Guernsey' },
  { value: 'GH', label: 'GH - Ghana', name: 'Ghana' },
  { value: 'GI', label: 'GI - Gibraltar', name: 'Gibraltar' },
  { value: 'GL', label: 'GL - Greenland', name: 'Greenland' },
  { value: 'GM', label: 'GM - Gambia', name: 'Gambia' },
  { value: 'GN', label: 'GN - Guinea', name: 'Guinea' },
  { value: 'GP', label: 'GP - Guadeloupe', name: 'Guadeloupe' },
  { value: 'GQ', label: 'GQ - Equatorial Guinea', name: 'Equatorial Guinea' },
  { value: 'GR', label: 'GR - Greece', name: 'Greece' },
  {
    value: 'GS',
    label: 'GS - South Georgia & South Sandwich Islands',
    name: 'South Georgia & South Sandwich Islands',
  },
  { value: 'GT', label: 'GT - Guatemala', name: 'Guatemala' },
  { value: 'GU', label: 'GU - Guam', name: 'Guam' },
  { value: 'GW', label: 'GW - Guinea-Bissau', name: 'Guinea-Bissau' },
  { value: 'GY', label: 'GY - Guyana', name: 'Guyana' },
  { value: 'HK', label: 'HK - Hong Kong', name: 'Hong Kong' },
  {
    value: 'HM',
    label: 'HM - Heard Island and McDonald Islands',
    name: 'Heard Island and McDonald Islands',
  },
  { value: 'HN', label: 'HN - Honduras', name: 'Honduras' },
  { value: 'HR', label: 'HR - Croatia', name: 'Croatia' },
  { value: 'HT', label: 'HT - Haiti', name: 'Haiti' },
  { value: 'HU', label: 'HU - Hungary', name: 'Hungary' },
  { value: 'ID', label: 'ID - Indonesia', name: 'Indonesia' },
  { value: 'IE', label: 'IE - Ireland', name: 'Ireland' },
  { value: 'IL', label: 'IL - Israel', name: 'Israel' },
  { value: 'IM', label: 'IM - Isle of Man', name: 'Isle of Man' },
  { value: 'IN', label: 'IN - India', name: 'India' },
  {
    value: 'IO',
    label: 'IO - British Indian Ocean Territory',
    name: 'British Indian Ocean Territory',
  },
  { value: 'IQ', label: 'IQ - Iraq', name: 'Iraq' },
  { value: 'IR', label: 'IR - Iran', name: 'Iran' },
  { value: 'IS', label: 'IS - Iceland', name: 'Iceland' },
  { value: 'IT', label: 'IT - Italy', name: 'Italy' },
  { value: 'JE', label: 'JE - Jersey', name: 'Jersey' },
  { value: 'JM', label: 'JM - Jamaica', name: 'Jamaica' },
  { value: 'JO', label: 'JO - Jordan', name: 'Jordan' },
  { value: 'JP', label: 'JP - Japan', name: 'Japan' },
  { value: 'KE', label: 'KE - Kenya', name: 'Kenya' },
  { value: 'KG', label: 'KG - Kyrgyzstan', name: 'Kyrgyzstan' },
  { value: 'KH', label: 'KH - Cambodia', name: 'Cambodia' },
  { value: 'KI', label: 'KI - Kiribati', name: 'Kiribati' },
  { value: 'KM', label: 'KM - Comoros', name: 'Comoros' },
  { value: 'KN', label: 'KN - Saint Kitts and Nevis', name: 'Saint Kitts and Nevis' },
  { value: 'KP', label: 'KP - North Korea', name: 'North Korea' },
  { value: 'KR', label: 'KR - South Korea', name: 'South Korea' },
  { value: 'KW', label: 'KW - Kuwait', name: 'Kuwait' },
  { value: 'KY', label: 'KY - Cayman Islands', name: 'Cayman Islands' },
  { value: 'KZ', label: 'KZ - Kazakhstan', name: 'Kazakhstan' },
  { value: 'LA', label: 'LA - Laos', name: 'Laos' },
  { value: 'LB', label: 'LB - Lebanon', name: 'Lebanon' },
  { value: 'LC', label: 'LC - Saint Lucia', name: 'Saint Lucia' },
  { value: 'LI', label: 'LI - Liechtenstein', name: 'Liechtenstein' },
  { value: 'LK', label: 'LK - Sri Lanka', name: 'Sri Lanka' },
  { value: 'LR', label: 'LR - Liberia', name: 'Liberia' },
  { value: 'LS', label: 'LS - Lesotho', name: 'Lesotho' },
  { value: 'LT', label: 'LT - Lithuania', name: 'Lithuania' },
  { value: 'LU', label: 'LU - Luxembourg', name: 'Luxembourg' },
  { value: 'LV', label: 'LV - Latvia', name: 'Latvia' },
  { value: 'LY', label: 'LY - Libya', name: 'Libya' },
  { value: 'MA', label: 'MA - Morocco', name: 'Morocco' },
  { value: 'MC', label: 'MC - Monaco', name: 'Monaco' },
  { value: 'MD', label: 'MD - Moldova', name: 'Moldova' },
  { value: 'ME', label: 'ME - Montenegro', name: 'Montenegro' },
  { value: 'MF', label: 'MF - Saint Martin', name: 'Saint Martin' },
  { value: 'MG', label: 'MG - Madagascar', name: 'Madagascar' },
  { value: 'MH', label: 'MH - Marshall Islands', name: 'Marshall Islands' },
  { value: 'MK', label: 'MK - North Macedonia', name: 'North Macedonia' },
  { value: 'ML', label: 'ML - Mali', name: 'Mali' },
  { value: 'MM', label: 'MM - Myanmar', name: 'Myanmar' },
  { value: 'MN', label: 'MN - Mongolia', name: 'Mongolia' },
  { value: 'MO', label: 'MO - Macao', name: 'Macao' },
  { value: 'MP', label: 'MP - Northern Mariana Islands', name: 'Northern Mariana Islands' },
  { value: 'MQ', label: 'MQ - Martinique', name: 'Martinique' },
  { value: 'MR', label: 'MR - Mauritania', name: 'Mauritania' },
  { value: 'MS', label: 'MS - Montserrat', name: 'Montserrat' },
  { value: 'MT', label: 'MT - Malta', name: 'Malta' },
  { value: 'MU', label: 'MU - Mauritius', name: 'Mauritius' },
  { value: 'MV', label: 'MV - Maldives', name: 'Maldives' },
  { value: 'MW', label: 'MW - Malawi', name: 'Malawi' },
  { value: 'MX', label: 'MX - Mexico', name: 'Mexico' },
  { value: 'MY', label: 'MY - Malaysia', name: 'Malaysia' },
  { value: 'MZ', label: 'MZ - Mozambique', name: 'Mozambique' },
  { value: 'NA', label: 'NA - Namibia', name: 'Namibia' },
  { value: 'NC', label: 'NC - New Caledonia', name: 'New Caledonia' },
  { value: 'NE', label: 'NE - Niger', name: 'Niger' },
  { value: 'NF', label: 'NF - Norfolk Island', name: 'Norfolk Island' },
  { value: 'NG', label: 'NG - Nigeria', name: 'Nigeria' },
  { value: 'NI', label: 'NI - Nicaragua', name: 'Nicaragua' },
  { value: 'NL', label: 'NL - Netherlands', name: 'Netherlands' },
  { value: 'NO', label: 'NO - Norway', name: 'Norway' },
  { value: 'NP', label: 'NP - Nepal', name: 'Nepal' },
  { value: 'NR', label: 'NR - Nauru', name: 'Nauru' },
  { value: 'NU', label: 'NU - Niue', name: 'Niue' },
  { value: 'NZ', label: 'NZ - New Zealand', name: 'New Zealand' },
  { value: 'OM', label: 'OM - Oman', name: 'Oman' },
  { value: 'PA', label: 'PA - Panama', name: 'Panama' },
  { value: 'PE', label: 'PE - Peru', name: 'Peru' },
  { value: 'PF', label: 'PF - French Polynesia', name: 'French Polynesia' },
  { value: 'PG', label: 'PG - Papua New Guinea', name: 'Papua New Guinea' },
  { value: 'PH', label: 'PH - Philippines', name: 'Philippines' },
  { value: 'PK', label: 'PK - Pakistan', name: 'Pakistan' },
  { value: 'PL', label: 'PL - Poland', name: 'Poland' },
  { value: 'PM', label: 'PM - Saint Pierre and Miquelon', name: 'Saint Pierre and Miquelon' },
  { value: 'PN', label: 'PN - Pitcairn', name: 'Pitcairn' },
  { value: 'PR', label: 'PR - Puerto Rico', name: 'Puerto Rico' },
  { value: 'PS', label: 'PS - Palestine', name: 'Palestine' },
  { value: 'PT', label: 'PT - Portugal', name: 'Portugal' },
  { value: 'PW', label: 'PW - Palau', name: 'Palau' },
  { value: 'PY', label: 'PY - Paraguay', name: 'Paraguay' },
  { value: 'QA', label: 'QA - Qatar', name: 'Qatar' },
  { value: 'RE', label: 'RE - Réunion', name: 'Réunion' },
  { value: 'RO', label: 'RO - Romania', name: 'Romania' },
  { value: 'RS', label: 'RS - Serbia', name: 'Serbia' },
  { value: 'RU', label: 'RU - Russia', name: 'Russia' },
  { value: 'RW', label: 'RW - Rwanda', name: 'Rwanda' },
  { value: 'SA', label: 'SA - Saudi Arabia', name: 'Saudi Arabia' },
  { value: 'SB', label: 'SB - Solomon Islands', name: 'Solomon Islands' },
  { value: 'SC', label: 'SC - Seychelles', name: 'Seychelles' },
  { value: 'SD', label: 'SD - Sudan', name: 'Sudan' },
  { value: 'SE', label: 'SE - Sweden', name: 'Sweden' },
  { value: 'SG', label: 'SG - Singapore', name: 'Singapore' },
  { value: 'SH', label: 'SH - Saint Helena', name: 'Saint Helena' },
  { value: 'SI', label: 'SI - Slovenia', name: 'Slovenia' },
  { value: 'SJ', label: 'SJ - Svalbard and Jan Mayen', name: 'Svalbard and Jan Mayen' },
  { value: 'SK', label: 'SK - Slovakia', name: 'Slovakia' },
  { value: 'SL', label: 'SL - Sierra Leone', name: 'Sierra Leone' },
  { value: 'SM', label: 'SM - San Marino', name: 'San Marino' },
  { value: 'SN', label: 'SN - Senegal', name: 'Senegal' },
  { value: 'SO', label: 'SO - Somalia', name: 'Somalia' },
  { value: 'SR', label: 'SR - Suriname', name: 'Suriname' },
  { value: 'SS', label: 'SS - South Sudan', name: 'South Sudan' },
  { value: 'ST', label: 'ST - São Tomé and Príncipe', name: 'São Tomé and Príncipe' },
  { value: 'SV', label: 'SV - El Salvador', name: 'El Salvador' },
  { value: 'SX', label: 'SX - Sint Maarten', name: 'Sint Maarten' },
  { value: 'SY', label: 'SY - Syria', name: 'Syria' },
  { value: 'SZ', label: 'SZ - Eswatini', name: 'Eswatini' },
  { value: 'TC', label: 'TC - Turks and Caicos Islands', name: 'Turks and Caicos Islands' },
  { value: 'TD', label: 'TD - Chad', name: 'Chad' },
  { value: 'TF', label: 'TF - French Southern Territories', name: 'French Southern Territories' },
  { value: 'TG', label: 'TG - Togo', name: 'Togo' },
  { value: 'TH', label: 'TH - Thailand', name: 'Thailand' },
  { value: 'TJ', label: 'TJ - Tajikistan', name: 'Tajikistan' },
  { value: 'TK', label: 'TK - Tokelau', name: 'Tokelau' },
  { value: 'TL', label: 'TL - Timor-Leste', name: 'Timor-Leste' },
  { value: 'TM', label: 'TM - Turkmenistan', name: 'Turkmenistan' },
  { value: 'TN', label: 'TN - Tunisia', name: 'Tunisia' },
  { value: 'TO', label: 'TO - Tonga', name: 'Tonga' },
  { value: 'TR', label: 'TR - Turkey', name: 'Turkey' },
  { value: 'TT', label: 'TT - Trinidad and Tobago', name: 'Trinidad and Tobago' },
  { value: 'TV', label: 'TV - Tuvalu', name: 'Tuvalu' },
  { value: 'TW', label: 'TW - Taiwan', name: 'Taiwan' },
  { value: 'TZ', label: 'TZ - Tanzania', name: 'Tanzania' },
  { value: 'UA', label: 'UA - Ukraine', name: 'Ukraine' },
  { value: 'UG', label: 'UG - Uganda', name: 'Uganda' },
  { value: 'UM', label: 'UM - U.S. Outlying Islands', name: 'U.S. Outlying Islands' },
  { value: 'US', label: 'US - United States', name: 'United States' },
  { value: 'UY', label: 'UY - Uruguay', name: 'Uruguay' },
  { value: 'UZ', label: 'UZ - Uzbekistan', name: 'Uzbekistan' },
  { value: 'VA', label: 'VA - Vatican City', name: 'Vatican City' },
  {
    value: 'VC',
    label: 'VC - Saint Vincent and the Grenadines',
    name: 'Saint Vincent and the Grenadines',
  },
  { value: 'VE', label: 'VE - Venezuela', name: 'Venezuela' },
  { value: 'VG', label: 'VG - British Virgin Islands', name: 'British Virgin Islands' },
  { value: 'VI', label: 'VI - U.S. Virgin Islands', name: 'U.S. Virgin Islands' },
  { value: 'VN', label: 'VN - Vietnam', name: 'Vietnam' },
  { value: 'VU', label: 'VU - Vanuatu', name: 'Vanuatu' },
  { value: 'WF', label: 'WF - Wallis and Futuna', name: 'Wallis and Futuna' },
  { value: 'WS', label: 'WS - Samoa', name: 'Samoa' },
  { value: 'YE', label: 'YE - Yemen', name: 'Yemen' },
  { value: 'YT', label: 'YT - Mayotte', name: 'Mayotte' },
  { value: 'ZA', label: 'ZA - South Africa', name: 'South Africa' },
  { value: 'ZM', label: 'ZM - Zambia', name: 'Zambia' },
  { value: 'ZW', label: 'ZW - Zimbabwe', name: 'Zimbabwe' },
];

/**
 * Validates whether a country code string is a valid ISO 3166-1 alpha-2 code.
 * @param {string} code - The country code to validate.
 * @returns {boolean} True if valid ISO 3166-1 alpha-2 code, false otherwise.
 */
export const isValidCountryCode = (code: string): boolean => {
  if (!code) {
    return false;
  }
  const formattedCode = code.trim().toUpperCase();
  return ISO_COUNTRY_CODES.some((country) => country.value === formattedCode);
};

/**
 * Resolves the display name of a country from its ISO 3166-1 alpha-2 code.
 * Falls back to localized string if available, ISO country name, or the code itself.
 * @param {string} countryCode - The ISO country code (e.g. 'SA', 'US', 'IN').
 * @param {any} t - The translation function.
 * @returns {string} The resolved country name.
 */
export const getCountryName = (countryCode: string, t?: any): string => {
  if (!countryCode) return '';
  const code = countryCode.toUpperCase();
  if (t) {
    const translationKeyMap: Record<string, string> = {
      IN: 'india',
      SA: 'saudiArabia',
      US: 'unitedStates',
      AE: 'uae',
    };
    const key = translationKeyMap[code];
    if (key) {
      const translated = t(key);
      if (translated && translated !== key) {
        return translated;
      }
    }
  }
  const country = ISO_COUNTRY_CODES.find((c) => c.value === code);
  return country ? country.name : countryCode;
};

